import { Popover, Transition } from '@headlessui/react'
import React, { Fragment, useEffect, useState } from 'react'
import { AiOutlineLock, AiOutlineSetting } from 'react-icons/ai'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { RiSendPlaneFill } from 'react-icons/ri'
import { ImUserTie } from 'react-icons/im'
import { chatData } from '../../data/ChatData'
import {
  useGetMessagesMutation,
  useLazyCurrentUserQuery,
} from '../../features/chat/chatSlice'
import { useSelector } from 'react-redux'
import { selectCurrentToken } from '../../features/auth/authSlice'
import { io } from 'socket.io-client'
import { formatDateWithTimeAndDate } from '../../utils/formatDate'
import { Loader } from '../../shared/Loader'

export const Chat = () => {
  const token = useSelector(selectCurrentToken)
  const [socket, setSocket] = useState<any>(null)
  const [message, setMessage] = useState<string>('')
  const [messages, setMessages] = useState<any[]>([])

  const [getMessages, { isLoading, isSuccess, data }] = useGetMessagesMutation()
  const [getCurrentUser] = useLazyCurrentUserQuery()

  console.log(messages)

  const addNewMessage = (message: any) => {
    setMessages((prev) => {
      if (prev.find((m) => m._id === message._id)) return prev
      return [message, ...prev]
    })
  }

  useEffect(() => {
    if (!token) return
    const socket = io('wss://api.gcbuying.com/chats', {
      withCredentials: true,
      transports: ['websocket'],
      upgrade: false,
      auth: {
        token: token,
      },
    })

    socket.on('connect', () => {
      console.log(`Connected with socket ID: ${socket.id}.`)
    })

    socket.on('connect_error', async (err) => {
      console.log('WS connect_error: ', err.message)
      socket.disconnect()
      if (err.message === 'UNAUTHORIZED') {
        // TODO: Refresh token and retry
        await getCurrentUser({ time: Date.now() })
      }
    })

    socket.on('exception', (error) => {
      console.log('WS exception: ', error)
    })

    socket.on('disconnect', (reason) => {
      console.log('WS disconnect: ', reason)
    })

    setSocket(socket)
    socket.on('message', (data) => {
      console.log(data)
      addNewMessage(data)
    })
    return () => {
      socket.disconnect()
    }
  }, [token])

  useEffect(() => {
    getMessages({})
    return () => setMessages([])
  }, [token])

  useEffect(() => {
    if (!data) return
    setMessages(data?.data)
  }, [data])

  const onSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const res = await socket?.emitWithAck('message', {
      message: message,
    })
    console.log(res)
    addNewMessage(res)
    setMessage('')
  }

  return (
    <div className='font-dashboard pt-4 pb-12 px-4 min-h-screen'>
      <div className='max-w-3xl mx-auto relative'>
        <div className='flex justify-between items-center p-4 bg-black z-10'>
          <div className='flex gap-4'>
            <div className='w-10 h-10 rounded-md bg-green-500 overflow-hidden flex justify-center items-center'>
              <ImUserTie className='text-2xl text-white' />
            </div>
            <div className='flex flex-col'>
              <h3 className='text-white/80 text-base'>Admin</h3>
              <div className='flex items-center gap-1'>
                <div className='w-2 h-2 rounded-full bg-green-500'></div>
                {/* <div className='w-2 h-2 rounded-full bg-red-500'></div> */}
                {/* <div className='w-2 h-2 rounded-full bg-yellow-500'></div> */}
                <p className='text-xs text-white/40'>Online</p>
                {/* <p className='text-xs text-white/40'>Offline</p> */}
                {/* <p className='text-xs text-white/40'>Away</p> */}
              </div>
            </div>
          </div>

          {/* <Popover as='div' className='relative'>
            <Popover.Button className='flex items-center'>
              <BsThreeDotsVertical className='text-lg text-white/70' />
            </Popover.Button>

            <Transition
              as={Fragment}
              enter='transition ease-in duration-200'
              enterFrom='opacity-0 translate-y-1'
              enterTo='opacity-100 translate-y-0'
              leave='transition ease-linear duration-150'
              leaveFrom='opacity-100 translate-y-0'
              leaveTo='opacity-0 translate-y-1'
            >
              <Popover.Panel className='absolute z-10 top-[2.6rem] w-[250px] right-0 bg-gray-700 shadow-lg rounded-lg py-2'>
                <div className='flex flex-col'>
                  <div className='transition-all duration-200 flex items-center gap-3 cursor-pointer px-4 py-3 hover:bg-gray-500'>
                    <AiOutlineLock className='text-white/80 text-xl' />
                    <p className='text-white/50 text-sm'>Menu 1</p>
                  </div>
                  <hr className='border-gray-600' />

                  <div className='transition-all duration-200 flex items-center gap-3 cursor-pointer px-4 py-3 hover:bg-gray-500'>
                    <AiOutlineSetting className='text-white/80 text-xl' />
                    <p className='text-white/50 text-sm'>Menu 2</p>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </Popover> */}
        </div>

        <div className='relative h-[65vh] w-full bg-gray-500 px-4 py-2 overflow-y-scroll flex flex-col-reverse'>
          {/* <div className='mt-4'>
            <hr className='border-white/10 w-full' />{' '}
            <p className='text-white text-base mx-auto -translate-y-4 bg-gray-500 max-w-[70px] px-3 py-1'>
              Today
            </p>
          </div> */}

          {isLoading ? (
            <div className='w-full h-[60vh] flex justify-center items-center'>
              <Loader />
            </div>
          ) : (
            messages?.map((chat) => (
              <div
                className={`flex gap-3 my-2 ${chat?.isAdmin === false ? 'justify-end' : 'justify-start'
                  }  group`}
              >
                <div
                  className={`flex flex-col gap-1 ${chat?.isAdmin === false ? 'order-1' : 'order-2'
                    }`}
                >
                  <h3
                    className={`text-white/80 text-base ${chat?.isAdmin === false ? 'self-end' : ''
                      } flex items-center gap-3`}
                  >
                    <p
                      className={`${chat?.isAdmin === true ? 'order-2' : ''
                        } text-sm`}
                    >
                      {chat?.isAdmin === false ? 'You' : 'Admin'}
                    </p>{' '}
                  </h3>
                  <div
                    className={`text-sm ${chat?.isAdmin === false
                        ? 'bg-primary rounded-tl-lg self-end'
                        : 'bg-gray-400 rounded-tr-lg'
                      }  rounded-b-lg px-4 py-2 max-w-max`}
                  >
                    {chat?.message}
                  </div>
                  <span className='text-xs text-white/40'>
                    {formatDateWithTimeAndDate(chat?.createdAt)}
                  </span>
                </div>
              </div>
            ))
          )}
        </div>

        <form
          action=''
          className='bg-gray-500 py-3 px-4'
          onSubmit={onSubmitHandler}
        >
          <div className='w-full bg-zinc-700 px-2 py-1 rounded-full flex items-center justify-between'>
            <input
              type='text'
              name='message'
              id='message'
              placeholder='Your message...'
              value={message}
              autoComplete='off'
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setMessage(e.target.value)
              }
              className='px-4 py-2 bg-transparent focus:outline-none w-full text-white'
            />

            <button type='submit'>
              <RiSendPlaneFill className='transition-all duration-200 text-lg text-white bg-violet-500 hover:bg-violet-500/70 box-content p-2 rounded-full cursor-pointer' />
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
